import {OperatorType, ConditionClassMap} from "./ConditionClassMap";
import {delayDebounced} from "../../../utils/Utils";
import {evaluateTemplate} from "../../TemplateEvaluation";


/** @return {Condition} */
export function parseConditionNode(journey, node, requestReEval) {
    // Array is implicitly treated as an "and" operator.
    if (Array.isArray(node)) {
        node = {type: OperatorType.AND, ops: node};
    }

    // A node with the exclude key set is negated.
    if (node.exclude) {
        node = {type: OperatorType.NOT, op: {...node, exclude: undefined}};
    }

    // A string node is considered a condition of that type.
    if (typeof node === "string" || node instanceof String) {
        node = {type: node};
    }

    const conditionClass = ConditionClassMap[node.type];
    if (!conditionClass) {
        throw `Unknown condition type: ${node.type}`;
    }
    const condition = new conditionClass(journey, node, requestReEval);
    if (node.type === OperatorType.AND || node.type === OperatorType.OR) {
        condition.ops = node.ops.map(subCondition => parseConditionNode(journey, subCondition, requestReEval));
    }
    if (node.type === OperatorType.NOT) {
        condition.ops = [parseConditionNode(journey, node.op, requestReEval)];
    }
    return condition;
}


export class ConditionEvaluator {
    constructor(journey, conditionOptions, callback) {
        this.journey = journey;
        this.callback = callback;
        const evaluatedConditionOptions = evaluateTemplate(conditionOptions);
        const evaluateDebounced = delayDebounced(() => this.evaluate(), 0);
        this.condition = parseConditionNode(journey, evaluatedConditionOptions, evaluateDebounced);
        this.evaluate();
    }

    evaluate() {
        const result = this.condition.evaluate();
        this.callback(result, this.journey);
    }

    cleanup() {
        this.condition.cleanup();
    }
}
